import { Unit } from '../../../components/ServiceItem';
import { PatientProps } from '../../../contexts/PatientContext';
import { ScheduleCardProps } from '../../../contexts/ScheduleContext';
import { ProductItemProps } from '../../../models/Product';
import { ScheduleItemProps, typeLocationSchedule } from '../../../models/Schedule';
import { ScheduleSpecialist } from '../../../models/ScheduleSpecialist';

export function makeScheduleCard(props: {
  patient: PatientProps;
  schedule: ScheduleItemProps;
  unit: Unit | undefined;
  product: ProductItemProps;
}) {
  const { schedule, patient, unit, product } = props;
  const scheduleCard = {} as ScheduleCardProps;
  scheduleCard.patient = patient;
  scheduleCard.schedule = schedule;
  if (unit) scheduleCard.unit = unit;

  scheduleCard.product = product;
  return scheduleCard;
}

export function makeScheduleCardSpecialist(props: { scheduleSpecialist: ScheduleSpecialist; patient: PatientProps }) {
  const infoScheduleCard = {} as ScheduleCardProps;
  const unit = {} as Unit;
  unit.name = props.scheduleSpecialist.unit.name;
  unit.address = props.scheduleSpecialist.unit.address || '';
  infoScheduleCard.unit = unit;

  infoScheduleCard.patient = props.patient;

  const product = {} as ProductItemProps;
  product.name = props.scheduleSpecialist.catalog.name;
  infoScheduleCard.product = product;

  const schedule = {} as ScheduleItemProps;
  schedule.date = props.scheduleSpecialist.date;
  schedule.startHour = props.scheduleSpecialist.hour;
  schedule.payment = {
    ...props.scheduleSpecialist.payment,
    ...(props.scheduleSpecialist.payment?.price ? { price: props.scheduleSpecialist.payment?.price } : {})
  };
  infoScheduleCard.schedule = schedule;
  const resource = {
    name: props.scheduleSpecialist.resource.name,
    roleList: props.scheduleSpecialist.specialityList,
    role: '',
    crm: '',
    image: props.scheduleSpecialist.image
  };
  schedule.resource = resource;
  schedule.useResouce = true;
  schedule.time = {
    id: '',
    time: new Date(`${props.scheduleSpecialist.date}T${props.scheduleSpecialist.hour}:00`),
    slots: []
  };
  schedule.careType = props.scheduleSpecialist.attendanceType;

  return infoScheduleCard;
}
